import { Injectable } from '@angular/core';
import { EventType } from '../../event-type/shared/event-type.model';
import { IEventTypeService } from './ievent-type.service';
import { ApiService, ApiCacheOptions, PagedResultGeneric } from '../../../shared/index';

@Injectable()
export class EventTypeService implements IEventTypeService {
  public _apiService: ApiService;
  private _cacheOptions: ApiCacheOptions;
  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._cacheOptions = this._apiService.getDefaultApiCacheOptionsForInfrequentlyChangedData();
  }

  getEventType = (eventType: string): Promise<EventType> => {
    let url: string = '/eventtype/?type=' + encodeURIComponent(eventType);
    return this._apiService.get(url, this._cacheOptions);
  };

  searchEventTypes = (searchParams: any, forceRefresh?: boolean): Promise<PagedResultGeneric<EventType>> => {
    let url: string = '/eventtypes';
    const cacheOptions = forceRefresh ? this._apiService.getDefaultApiCacheOptionsForNoCache() : this._cacheOptions;
    return this._apiService.getPaged(url, searchParams, cacheOptions);
  };

  public getEventTypes = (): Promise<Array<string>> => {
    let url: string = '/Events/EventTypes'; //Array<string>
    return this._apiService.get(url);
  };

  public upsertEventType = (eventType: EventType): Promise<string> => {
    let url: string = '';
    url = '/EventType/Upsert';
    return this._apiService.post(url, eventType).then(
      (data: string): Promise<string> => {
        return Promise.resolve(data);
      }
    );
  };

  public deleteEventType = (eventType: string, eventTypeToMigrateTo?: string): Promise<void> => {
    let url: string = '';

    url = '/EventType?type=' + encodeURIComponent(eventType) + '&typeToMigrateTo=' + encodeURIComponent(eventTypeToMigrateTo);
    return this._apiService.deleteData(url, { typeToMigrateTo: eventTypeToMigrateTo }).then(
      (): Promise<void> => {
        return Promise.resolve();
      }
    );
  };
}
